import { observer } from "mobx-react";
import React from "react";
import { Button } from "@material-ui/core";
import { FaExpand, FaCompress } from "react-icons/fa";
import { MdFileDownload } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import styled from "styled-components";

function PivotButtons(props) {
    if (!props.store) {
        return null;
    }

    return (
        <div
            className="textCenter d-flex"
            style={{ alignItems: "center" }}
        >
            <StyledDownloadDiv>
                <MdFileDownload
                    size={18}
                    color={COLORS.TEXT_COLOR}
                    onClick={() => {
                        window.appStore?.currentViewStore?.executeActionCommand('export-all');
                    }}
                />
            </StyledDownloadDiv>
            <Button onClick={() => {
                window.appStore?.currentViewStore?.executeActionCommand('expand-all');
            }}>
                <FaExpand size="10" style={{ margin: 5 }} />
                Expand All
            </Button>

            <Button onClick={() => {
                window.appStore?.currentViewStore?.executeActionCommand('collapse-all');
            }}>
                <FaCompress size="10" style={{ margin: 5 }} />
            Collapse All</Button>
        </div>
    )
}

const StyledDownloadDiv = styled.div`
  margin: 3px;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
`;
export default observer(PivotButtons);